<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import Header from "../components/header.svelte"
    //import Home from "./routes/home.svelte";

    export var auth;
    export var db;

    export let location;
    location = location;

    function goLogin() {
      navigate("/login", { replace: true });
  }



  var name = ""
  var sirname = ""
  var email = ""
  var password = ""
  var tel;
  var adresse;
  var don = false;
 var eula = false; 

 function toggleEula(){
     eula = !eula
     console.log('eula : '+eula)
 }

  function inscription(){
      console.log(eula)
      if (eula){
        auth.createUserWithEmailAndPassword(email, password).then((userCredential) => {
        var user = userCredential.user;
        var user = firebase.auth().currentUser;
        user.sendEmailVerification().then(function() {
                // Email sent.
        }).catch(function(error) {
         // An error happened.
        });
        var tempName = name.toUpperCase().split("")
        var tempSirname = sirname.toUpperCase().split("")
        var noInscrit = tempName[0] + tempName[1] + tempSirname[0] + tempSirname[1] + tempSirname[2]   
        return db.collection('users').doc(user.uid).set({
            name:name,
            sirname:sirname,
            email:email,
            tel:tel,
            adresse:adresse,
            nbJouets :0,
            prixTotal:0,
            nbVendus:0,
            gain:0,
            rdv:"",
            noInscrit:noInscrit,
            statut:"no",
            isAdmin: false,
            don:don
        })
    

  }).then(() => {
    navigate("/user", { replace: true });
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.log(errorMessage)
    // ..
  });

      }
      else{
          alert("Veuillez à valider les conditions d'utilisation")
      }
  }

</script>







<main>
    <Header>
        <div class="elm">A propos</div>
        <div class="elm">Contact</div>
    </Header>
    
 
        <form class="form">
        <p style="font-size :3rem;user-select:none;">S'inscrire</p>
        <input class="inputt" type="text" id="prenom" placeholder="Prénom" bind:value={name}>
        <input class="inputt" type="text" id="nom" placeholder="Nom" bind:value={sirname}>
        <input class="inputt" type="email" id="mail" placeholder="E-mail" bind:value={email}>
        <input class="inputt" type="password" id="mdp" placeholder="Mot de passe" bind:value={password}>
        <input class="inputt" type="tel" id="adresse" pattern="[0-9]{5}" placeholder="Code Postal" bind:value={adresse}>
        <input class="inputt" type="tel" id="phone" name="phone" placeholder="Téléphone" pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{2}" bind:value={tel}>
        <p><input  type="checkbox" id="don" bind:value={don}><label style="margin-left:10px;"for="don">Je souhaiite faire don de mes articles invendus</label></p>
        <p><input  type="checkbox" id="eula" on:change={toggleEula}><label style="margin-left:10px;"for="eula">J'accepte les conditions d'utilisaton </label></p>
        <p class="forgot" on:click={goLogin}>Se connecter</p>
        <button type="submit" class="submit" on:click|preventDefault={inscription} ><img src="https://img.icons8.com/ios-glyphs/60/ffffff/arrow.png" alt="fleche"/></button>
        </form>
</main>
 


<style>
    main{
        display: flex;
        flex-direction: column;
        width: 100vw;
        min-height: 100vh;
        background-color: #262626;
        align-items: center;
    }

    label{
        display: inline;
    }
    .elm{
        margin-right: 20px;
        cursor: pointer;
    }

    .form{
        margin-top: 20vh;
        width: 30vw;
        height: fit-content;
        border-radius: 66px;
        background: #262626;
        box-shadow:  20px 20px 56px #151515,
         -20px -20px 56px #373737;
         display: flex;
         flex-direction: column;
         align-items: center;
         color: white;
         font-family: 'Poppins', sans-serif;
        font-weight: 400;
        margin-bottom: 15vh;
    }


    input{
        border: none;
    }
    .inputt{
        padding: 10px;
        background-color: transparent;
        margin: 15px;
        height: 5vh;
        width: 50%;
        outline: none;
        border-bottom: 3px solid white;
        color: white;

    }

    .inputt:hover{
        background-color: rgba(255, 255, 255, 0.1);
    }

    .forgot{
        margin-top: 20px;
        opacity: 0.5;
        cursor: pointer;
    }

    .forgot:hover{
        opacity: 1;
    }

    .submit{
        user-select: none;
        cursor: pointer;
        align-self: flex-end;
        border-radius: 50%;
        margin-right: 10%;
        margin-top: 10%;
        padding-bottom: 10%;
        width: fit-content;
        height: auto;
        padding: 15px;
        border-radius: 106px;
        background: #262626;
        box-shadow:  9px 9px 18px #111111,
             -9px -9px 18px #3b3b3b;
    }



</style>